import React, { FC, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select as MuiSelect } from '@material-ui/core';
import moment from 'moment';

import { uniqueId } from 'lodash';

import DateTimePicker from './DateTime';

interface IProps {
  value: number;
  setValue: (val: number) => void;
  minDate?: string;
  maxDate?: string;
  allowNull?: boolean;
  label?: string;
  fullWidth?: boolean;
  enableTime?: boolean;
  defaultValue?: string;
}

const Select: FC<IProps> = ({
  value,
  setValue,
  minDate,
  maxDate,
  allowNull,
  label,
  fullWidth,
  enableTime,
  defaultValue,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [dateId] = useState(uniqueId('dateSelect'));

  function onSave(time: number) {
    if (time || allowNull) {
      setValue(time);
    }
    setAnchorEl(null);
  }

  function renderMenuItem() {
    if (value) {
      return (
        <MenuItem value="item">{moment.unix(value).format(enableTime ? 'LLL' : 'LL')}</MenuItem>
      );
    }

    return <MenuItem value="item">{defaultValue}</MenuItem>;
  }

  return (
    <FormControl fullWidth={fullWidth}>
      {!!label && <InputLabel htmlFor={dateId}>{label}</InputLabel>}
      <MuiSelect
        value="item"
        readOnly
        onClick={event => setAnchorEl(event.currentTarget)}
        inputProps={{
          id: dateId,
        }}
      >
        {renderMenuItem()}
      </MuiSelect>
      <DateTimePicker
        value={value}
        anchorEl={anchorEl}
        onSave={onSave}
        onClose={() => onSave(null)}
        minDate={minDate}
        maxDate={maxDate}
        enableTime={enableTime}
      />
    </FormControl>
  );
};

export default Select;
